import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import {
  GETCHARTDATA,
  GETDASHBOARDTAGDATA,
  GETDEADLINESTATUSSTATS,
  GETEVENTSOVERVIEW,
  GETEVENTSRESPONSERATE,
  GETEVENTSRESPONSERATEGRID,
  GETMANDATORYMESSAGEOVERALLSTATS,
  GETMESSAGERECIPIENTS,
  GETMESSAGESGRID,
  GETRECENTGROUPSANDEVENTS,
} from '../endpoints';

export const getTagDataForDashboard = async () => {
  const response = await client.get(`${baseUrl}${GETDASHBOARDTAGDATA}`);
  return response;
};

export const getRecentEventsAndGroups = async () => {
  const response = await client.get(`${baseUrl}${GETRECENTGROUPSANDEVENTS}`);
  return response;
};

export const getChartData = async ({
  fromDate,
  toDate,
}: {
  fromDate: string;
  toDate: string;
}) => {
  const response = await client.get(
    `${baseUrl}${GETCHARTDATA}?fromDate=${fromDate}&toDate=${toDate}`
  );
  return response;
};

export const getMandatoryMessageOverAllStats = async () => {
  const response = await client.get(
    `${baseUrl}${GETMANDATORYMESSAGEOVERALLSTATS}`
  );
  return response;
};

export const getMandatoryMessageGrids = async ({
  page,
  size,
}: {
  page: number;
  size: number;
}) => {
  const response = await client.get(`${baseUrl}${GETMESSAGESGRID}`, {
    params: {
      page,
      size,
    },
  });
  return response.data;
};

export const getDeadLineStatusStats = async () => {
  const response = await client.get(`${baseUrl}${GETDEADLINESTATUSSTATS}`);
  return response;
};

export const getMessageRecipientsById = async (messageId: number) => {
  const response = await client.get(
    `${baseUrl}${GETMESSAGERECIPIENTS}/${messageId}`
  );
  return response;
};

export const getEventsOverview = async () => {
  const response = await client.get(`${baseUrl}${GETEVENTSOVERVIEW}`);
  return response;
};

export const getEventsMessaageResponseRate = async () => {
  const response = await client.get(`${baseUrl}${GETEVENTSRESPONSERATE}`);
  return response;
};

export const getEventsDataGrid = async ({
  page,
  size,
}: {
  page: number;
  size: number;
}) => {
  const response = await client.get(`${baseUrl}${GETEVENTSRESPONSERATEGRID}`, {
    params: {
      page,
      size,
    },
  });
  return response.data;
};
